import React from 'react';

import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FilterDashboardFourriereProps } from '../../../types';

function InputIdAlienation({
  values,
}: FilterDashboardFourriereProps): React.ReactElement {
  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: 'idAlienation',
        itemProps: {
          label: 'Id Alienation',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputIdAlienation;
